/**
 * @desc 默认列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.ApiResponseResponseDto>>;
export function request(
  params: API.appCenter.api.defaultColumn.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/api/default`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
